angular.module('user')
    .component('userAvatar', {
        bindings: {
            user: '<',
            size: '<',
            fontSize: "<",
            filterOptions: '<',
            noDropdown: '<',
            showInactiveBadge: '<'
        },
        template: `
            <span ng-if="$ctrl.hasUser() && !$ctrl.hasDropdown()">
                <span ng-style="$ctrl.avatarWrapStyle">
                    <span ng-style="$ctrl.avatarContentStyle">
                        <ng-letter-avatar charCount="2" dynamic="true" data="{{$ctrl.user.fullName}}" fontsize="{{::$ctrl.fontSize}}" height="{{::$ctrl.size}}" width="{{::$ctrl.size}}" ng-if="$ctrl.user.avatar === false"></ng-letter-avatar>
                        <img alt="{{$ctrl.user.fullName}}" width="{{::$ctrl.size}}" height="{{::$ctrl.size}}" ng-src="/crm/users/{{$ctrl.user.id}}/avatar" title="{{$ctrl.user.fullName}}" ng-if="$ctrl.user.avatar === true"/>
                    </span>
                    <span ng-if="$ctrl.isInactiveBadgeVisible()" ng-style="$ctrl.inactiveBadgeStyle" uib-tooltip="Użytkownik nieaktywny">
                        <i class="fa fa-ban"></i>
                    </span>
                </span>
            </span>

            <div class="btn-group" ng-if="$ctrl.hasUser() && $ctrl.hasDropdown()" uib-dropdown auto-dropdown dropdown-append-to-body is-open="$ctrl.dropdownOpen" on-toggle="$ctrl.onDropdownToggle(open)">
                <a href uib-dropdown-toggle ng-click="$event.preventDefault()">
                    <span ng-style="$ctrl.avatarWrapStyle">
                        <span ng-style="$ctrl.avatarContentStyle">
                            <ng-letter-avatar charCount="2" dynamic="true" data="{{$ctrl.user.fullName}}" fontsize="{{::$ctrl.fontSize}}" height="{{::$ctrl.size}}" width="{{::$ctrl.size}}" ng-if="$ctrl.user.avatar === false"></ng-letter-avatar>
                            <img alt="{{$ctrl.user.fullName}}" width="{{::$ctrl.size}}" height="{{::$ctrl.size}}" ng-src="/crm/users/{{$ctrl.user.id}}/avatar" title="{{$ctrl.user.fullName}}" ng-if="$ctrl.user.avatar === true"/>
                        </span>
                        <span ng-if="$ctrl.isInactiveBadgeVisible()" ng-style="$ctrl.inactiveBadgeStyle" uib-tooltip="Użytkownik nieaktywny">
                            <i class="fa fa-ban"></i>
                        </span>
                    </span>
                </a>
                <ul class="dropdown-menu-right text-left" uib-dropdown-menu>
                    <li class="dropdown-header" style="font-size: x-small;">
                        {{$ctrl.user.fullName}}
                    </li>
                    <li role="menuitem">
                        <a href ng-click="$ctrl.showUserProfile($event)">
                            <span style="padding-right: 5px; display: inline-flex; vertical-align: middle;">
                                <user-avatar user="$ctrl.user" size="20" font-size="11" no-dropdown="true"></user-avatar>
                            </span>
                            Pokaż profil
                        </a>
                    </li>
                    <li class="divider" ng-if="$ctrl.hasContactActions()"></li>
                    <li class="dropdown-header" style="font-size: x-small;" ng-if="$ctrl.hasContactActions()">Kontakt</li>
                    <li role="menuitem" ng-if="$ctrl.hasEmail()"><a href ng-click="$ctrl.sendEmail($event)"><i class="fa fa-fw fa-envelope-o"></i>Wyślij email</a></li>
                    <li role="menuitem" ng-if="$ctrl.hasPhone()"><a href ng-click="$ctrl.sendSms($event)"><i class="fa fa-fw fa-mobile-phone"></i>Wyślij SMS</a></li>
                    <li class="divider" has-any-authority="ROLE_ADMIN, ROLE_USER_MANAGEMENT"></li>
                    <li class="dropdown-header" style="font-size: x-small;" has-any-authority="ROLE_ADMIN, ROLE_USER_MANAGEMENT">Administracja</li>
                    <li role="menuitem" has-any-authority="ROLE_ADMIN, ROLE_USER_MANAGEMENT">
                        <a href ng-click="$ctrl.editUser($event)"><i class="fa fa-fw fa-pencil"></i>Edytuj</a>
                    </li>
                    <li class="divider" ng-if="$ctrl.hasFilterMenu()"></li>
                    <li class="dropdown-header text-muted" style="font-size: x-small;" ng-if="$ctrl.hasFilterMenu()">
                        Filtry listy
                    </li>
                    <li ng-repeat="option in $ctrl.filterOptions track by $index">
                        <a href ng-click="$ctrl.applyFilter(option, $event)">
                            <i class="fa fa-fw fa-angle-right text-warning"></i>{{$ctrl.getOptionLabel(option)}}
                        </a>
                    </li>
                </ul>
            </div>
        `,
        controller: function ($filter, $injector, $state, $window, UserService) {
            this.$onInit = () => {
                this.size = this.size || 18;
                this.fontSize = this.fontSize || 11;
                this.filterOptions = angular.isArray(this.filterOptions) ? this.filterOptions : []
                this.showInactiveBadge = this.showInactiveBadge !== false
                this.SmsService = $injector.has('SmsService') ? $injector.get('SmsService') : null
                this.dropdownOpen = false
                this.refreshStyles()
            }

            this.$onChanges = () => {
                this.refreshStyles()
            }

            this.hasFilterMenu = () => {
                return !!(this.user && this.user.id && angular.isArray(this.filterOptions) && this.filterOptions.length > 0)
            }
            this.hasUser = () => !!this.user
            this.isInactive = () => {
                const user = this.user
                return !!(user && (user.activated === false || user.active === false))
            }
            this.isInactiveBadgeVisible = () => this.showInactiveBadge && this.isInactive()
            this.hasDropdown = () => {
                if (this.noDropdown) {
                    return false
                }
                return !!(this.user && this.user.id)
            }
            this.refreshStyles = () => {
                this.avatarWrapStyle = {
                    position: 'relative',
                    display: 'inline-block',
                    lineHeight: '0',
                    verticalAlign: 'middle'
                }
                this.avatarContentStyle = this.isInactiveBadgeVisible()
                    ? {
                        opacity: '0.4',
                        filter: 'grayscale(55%)'
                    }
                    : {}

                const avatarSize = this.size || 18
                const isSmallAvatar = avatarSize <= 22
                const badgeSize = Math.max(isSmallAvatar ? 10 : 11, Math.round(avatarSize * (isSmallAvatar ? 0.5 : 0.58)))
                const fontSize = Math.max(isSmallAvatar ? 8 : 9, Math.round(avatarSize * (isSmallAvatar ? 0.58 : 0.66)))
                const edgeOffset = isSmallAvatar ? -1 : -2

                this.inactiveBadgeStyle = {
                    position: 'absolute',
                    right: edgeOffset + 'px',
                    bottom: edgeOffset + 'px',
                    width: badgeSize + 'px',
                    height: badgeSize + 'px',
                    borderRadius: '50%',
                    background: '#d9534f',
                    color: '#fff',
                    border: '1px solid #fff',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: fontSize + 'px',
                    lineHeight: '1',
                    pointerEvents: 'none'
                }
            }
            this.hasEmail = () => {
                const user = this.user
                return !!(user && user.email)
            }
            this.hasPhone = () => {
                const user = this.user
                return !!(user && user.phone)
            }
            this.hasContactActions = () => {
                return this.hasEmail() || this.hasPhone()
            }

            this.getOptionLabel = option => {
                if (!option) {
                    return ''
                }
                if (option.labelKey) {
                    return $filter('translate')(option.labelKey)
                }
                return option.label || ''
            }

            this.resolveOptionParamValue = value => {
                if (value === '$userId') {
                    return this.user.id
                }
                return value
            }
            this.closeDropdown = () => this.dropdownOpen = false
            this.onDropdownToggle = open => this.dropdownOpen = open
            this.showUserProfile = ($event) => {
                if ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                }
                this.closeDropdown()
                if (!this.user || !this.user.id) {
                    return
                }
                UserService.userProfile(this.user)
            }
            this.sendEmail = ($event) => {
                if ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                }
                this.closeDropdown()
                if (!this.user || !this.user.email) {
                    return
                }
                $window.location.href = "mailto:" + this.user.email
            }
            this.sendSms = ($event) => {
                if ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                }
                this.closeDropdown()
                if (!this.user || !this.user.phone || !this.SmsService) {
                    return
                }
                this.SmsService.sendMessageToUser(this.user)
            }
            this.editUser = ($event) => {
                if ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                }
                this.closeDropdown()
                if (!this.user || !this.user.id) {
                    return
                }
                UserService.editModal(this.user.id)
            }

            this.applyFilter = (option, $event) => {
                if ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                }
                this.closeDropdown()
                if (!this.user || !this.user.id || !option) {
                    return
                }

                const params = angular.copy($state.params || {})
                params.page = null

                if (angular.isArray(option.clearParams)) {
                    option.clearParams.forEach(paramName => params[paramName] = null)
                }
                if (option.param) {
                    params[option.param] = this.user.id
                }
                if (option.params) {
                    Object.keys(option.params).forEach(paramName => {
                        params[paramName] = this.resolveOptionParamValue(option.params[paramName])
                    })
                }

                $state.go(option.state || $state.current.name, params, {inherit: false, reload: true, notify: false})
            }
        }
    })
